import useDarkMode from '../../../hooks/useDarkMode';
import useThemeColor from "../../../hooks/useThemeColor";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  onSubmit,
  showButton,
  showSubmitButton = true,
  showCancelButton = true,
  fontSize = "16px",
  fontWeight = "400",
  subtitleFontSize = "14px",
  subtitleFontWeight = "400",
  children,
  modalSize = "",
  minHeight = "200px",
  maxHeight = "550px",
  isCentered = false,
  submitButtonText = "Save", // New prop with default value "Save"
  submitButtonDisabled = false, // New prop for disabling submit button
  hideHeader = false,
  contentClassName = "",
  backdropClassName = "",


}) => {
  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

  // Theme accent for submit button (restaurant-scoped Redux + theme map)
  const themeColor = useThemeColor();

  
  if (!isOpen) return null;

  return (
    <div
      className={`modal fade show d-block ${backdropClassName}`.trim()}
      style={{ 
        backgroundColor: "rgba(0, 0, 0, 0.75)", 
        zIndex: 9999,
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "auto"
      }}
      onClick={onClose}
    >
      <div
        className={"modal-dialog " + modalSize}
        style={{
          display: isCentered ? "flex" : "block",
          justifyContent: isCentered ? "center" : "initial",
          alignItems: isCentered ? "center" : "initial",
          minHeight: isCentered ? "100vh" : "auto",
          margin: isCentered ? "0 auto" : "0.5rem auto",
          position: "relative",
         

        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`modal-content ${contentClassName}`.trim()}
          style={{
            borderRadius: "20px",
            minHeight: minHeight,
            maxHeight: maxHeight,
            backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
            border: isDarkMode ? '1px solid #404040' : '1px solid #dee2e6',
            color: isDarkMode ? '#ffffff' : '#000000',
            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
            position: 'relative',
            zIndex: 10001,
            // Ensure inner scroll areas and content don’t create a second box
            overflow: "hidden",
          }}
        >
          {!hideHeader && (
          <div
            className="modal-header"
            style={{ 
              border: "none", 
              paddingBottom: "0px",
              backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
              color: isDarkMode ? '#ffffff' : '#000000',
            }}
          >
            <div>
              <h5
                className="modal-title"
                style={{ 
                  fontSize: fontSize, 
                  fontWeight: fontWeight,
                  color: isDarkMode ? '#ffffff' : '#000000',
                }}
              >
                {title}
              </h5>
              {subtitle && (
                <p
                  className="modal-subtitle"
                  style={{
                    fontSize: subtitleFontSize,
                    fontWeight: subtitleFontWeight,
                    margin: "8px 0 0 0",
                    color: isDarkMode ? '#adb5bd' : "#666",
                  }}
                >
                  {subtitle}
                </p>
              )}
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          )}
          <div
            className="modal-body"
            style={{
              overflowY: "auto",
              maxHeight: hideHeader ? maxHeight : `calc(${maxHeight} - 100px)`,
              backgroundColor: isDarkMode ? '#2d3436' : '#ffffff',
              color: isDarkMode ? '#ffffff' : '#000000',
            }}
          >
            {children}
          </div>

          {showButton && (
            <div className="modal-footer" style={{ border: "none" }}>
              {showCancelButton && (
                <button
                  onClick={onClose}
                  type="button"
                  className="btn"
                  style={{ ...buttonStyles.base, ...buttonStyles.cancel }}
                >
                  Cancel
                </button>
              )}

              {showSubmitButton && (
                <button
                  onClick={onSubmit}
                  type="button"
                  className="btn"
                  disabled={submitButtonDisabled}
                  style={{ 
                    ...buttonStyles.base,
                    backgroundColor: submitButtonDisabled ? "#C4C4C4" : themeColor,
                    background: submitButtonDisabled ? "#C4C4C4" : `linear-gradient(135deg, ${themeColor} 0%, ${themeColor}dd 100%)`,
                    border: `1px solid ${themeColor}`,
                    boxShadow: submitButtonDisabled ? "none" : `0 4px 15px ${themeColor}40`,
                    transition: 'all 0.3s ease',
                    ...(submitButtonDisabled ? buttonStyles.disabled : {})
                  }}
                  onMouseEnter={(e) => {
                    if (!submitButtonDisabled) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = `0 6px 20px ${themeColor}60`;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!submitButtonDisabled) {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = `0 4px 15px ${themeColor}40`;
                    }
                  }}
                >
                  {submitButtonText} {/* Use the new prop here */}
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const buttonStyles = {
  base: {
    fontFamily: "Open Sans, sans-serif",
    fontWeight: "600",
    width: "107px",
    borderRadius: "10px",
    height: "40px",
    padding: "8px 16px",
    border: "none",
    outline: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "white",
  },
  cancel: {
    backgroundColor: "#C4C4C4",
    color: "#000",
  },
  disabled: {
    backgroundColor: "#C4C4C4",
    color: "#666",
    cursor: "not-allowed",
    opacity: 0.6,
  },
};

export default CustomModal;